<template>
  <div id="app">
    <div v-if="liad_show">
      <load></load>
    </div>
  <div class="maincon">
    <div>
      <el-date-picker
        v-model="time"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions">
      </el-date-picker>
      <el-button type="primary" @click="study_change()">检索</el-button>
      <el-button type="primary" @click="study_load_excel()">整体导出</el-button>
    </div>
    <div>
    <el-table stripe :data="study_list.list" style="width: 100%;margin-top: 20px;" :row-style="{height:'70px'}">
      <el-table-column label="姓名" prop="name" width="" sortable>
      </el-table-column>
      <el-table-column label="自学时长" prop="self" width="" sortable>
      </el-table-column>
      <el-table-column label="自学时长排名" prop="self_order" width="" sortable>
      </el-table-column>
      <el-table-column label="任务时长" prop="train" width="" sortable>
      </el-table-column>
      <el-table-column label="任务时长排名" prop="train_order" width="" sortable>
      </el-table-column>
      <el-table-column label="直播时长" prop="live" width="" sortable>
      </el-table-column>
      <el-table-column label="直播时长排名" prop="live_order" width="" sortable>
      </el-table-column>
      <el-table-column label="总时长" prop="total" width="" sortable>
      </el-table-column>
      <el-table-column label="总时长排名" prop="total_order" width="" sortable>
      </el-table-column>
    </el-table>
    </div>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="study_list.current_page" :page-sizes="[10, 20, 50, 100]" :page-size="study_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="study_list.total">
      </el-pagination>
    </div>

  </div>
  </div>
</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        liad_show:false,
        // companyee_list:{},
        study_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
          list:''
        },
        study_time:'_',
        time:null,
        search: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    components: {
       load:load
    },
    mounted() {
      this.get_study()
    },
    methods: {
      study_load_excel(){
        let _this=this
        _this.liad_show=true
        var data={}
        if(_this.time==null){
          data.time='_'
        }else{
          data.time=_this.time[0]+"_"+_this.time[1]
        }
        _this.axios.post('/v2/c_census/time_load_excel',{data:data},{responseType:'blob'}).then(function(res) {
          if(res.status=='200'){
            const blob = new Blob([res.data],{type: 'aplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
            const elink = document.createElement('a')
            elink.download = '员工时长统计详情.xlsx';
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
             _this.liad_show=false
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      study_change(){
        let _this=this
        _this.load=true
        if(_this.time==null){
          _this.study_time='_'
        }else{
          _this.study_time=_this.time[0]+"_"+_this.time[1]
        }
        _this.study_list.current_page=1
        _this.study_list.total=0
        _this.study_list.per_page=10
        _this.get_study()
        _this.load=false
      },

      get_study(){
        let _this=this
        _this.axios.get("/v2/c_census/get_study_total",{params:{'page':_this.study_list.current_page,'limit':_this.study_list.per_page,'time':_this.study_time}}).then(function (res) {
          if (res.status == "200") {
            _this.study_list=res.data
            _this.study_list.per_page=parseInt(_this.study_list.per_page)
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },

      handleSizeChange(val) {
        this.study_list.current_page = 1
        this.study_list.per_page = val
        this.get_study()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.study_list.current_page = val
        _this.get_study()
      },
    },
  }
</script>

<style scoped>
  #app{
   padding: 20px;
   background-color: white;
   height: 100%;
   padding-bottom: 5%;
  }
  .maincon {
   padding: 20px;
   /* height: calc(100vh - 40px); */
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/census/time/time.vue